import PromptContent from "slotworks/components/prompt/prompt-content";
import RetriggerFreespins from "slotworks/state-machine/standard/states/retrigger-freespins";
import { Services } from "slotworks/services/services";
import SmartUIFlags, { SmartUIFlag } from "slotworks/smart-ui/smart-ui-flags";

export default class SGRetriggerFreespins extends RetriggerFreespins {

    public onEnter() {
        SmartUIFlags.set(SmartUIFlag.NO_SKIP, true);

        this.showPrompt();
    }

    public complete() {
        SmartUIFlags.set(SmartUIFlag.NO_SKIP, false);

        super.complete();
    }

    protected showPrompt(prompt?: PromptContent) {
        prompt = new PromptContent(["freespinsretrigger"], 250);
        Services.sound.customEvent("fs-retrigger");
        super.showPrompt(prompt);
    }
}
